const list = [
  '24KiCK',
  '安体倍力',
  '奥美氧舱',
  'b-monster',
  '宝力豪',
  '超级猩猩',
  // '鼎尚健身',
  '第一体育',
  'FitU/飞优',
  '蜂狂运动',
  // '公园盒子',
  '古德菲力',
  '光猪圈',
  // 'GE快健身',
  '浩沙健身',
  '黄金时代健身',
  'Hyperfit',
  // '极跑吧',
  '健身者联盟',
  '嘉佑健身',
  '杰仕动能',
  '金吉鸟',
  'JUMPFIT',
  'K-EMS Studio',
  'Keepland',
  '快快健身',
  '乐刻运动',
  '练遇健身',
  'Liking健身',
  '力美健',
  '美格菲',
  '魔方运动',
  'Pure',
  '奇迹健身',
  '青鸟健身',
  '清橙健身',
  '人马君',
  '人马线',
  // '赛普健身',
  'Shape',
  '舒适堡',
  'SpaceCycle',
  '威尔士',
  '星之健身',
  'XONE运动空间',
  '壹健身',
  '蚁加私教',
  '一兆韦德',
  '银吉姆',
  '引力工场',
  // '银座健身',
  '英派斯健身',
  '中航健身',
  '中健健身',
  '中体倍力',
  'ZESPEED',
  '自由者健身'
]

const questions = [
  {
    title: '公司实力（参考标准：门店规模、资金实力、核心团队、品牌知名度）',
    options: []
  },
  {
    title:
      '薪酬福利（参考标准：基本工资、课时费、绩效考核、食宿支持、五险一金、带薪假期）',
    options: []
  },
  {
    title:
      '成长空间（参考标准：职业晋升、内训机制、培训费用、海外游学、多元化发展）',
    options: []
  },
  {
    title:
      '企业文化（参考标准：愿景使命、开放度、男女比例、国际化、工作环境、团建费用）',
    options: []
  }
]

const arr = []
const values = []

const obj = {
  value: false,
  disable: false
}

list.forEach(item => {
  const _item = Object.assign({ name: item }, obj)
  arr.push(_item)
  values.push(false)
})

questions.map(item => {
  item.options = arr
})

export { questions, values, list }
